export default {"src":"/_next/static/media/chevron-right-outline.c813a873.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};